import { render } from "./CheckSvg.vue?vue&type=template&id=165ce38a"
import script from "./CheckSvg.vue?vue&type=script&lang=js"
export * from "./CheckSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__